import * as requestActionTypes from 'services/Request/actionTypes'
import { ErrorBody } from './error'

export type StateType = {
  activeRequests: string[]
  errors: { [key: string]: ErrorBody }
}

const initialState = (): StateType => ({
  activeRequests: [],
  errors: {},
})

const requestReducer = (
  state = initialState(),
  action: ActionType,
): StateType => {
  const removeActiveReq = (key: string) =>
    [...state.activeRequests].filter(activeRequest => activeRequest !== key)

  switch (action.type) {
    case requestActionTypes.STARTED:
      return {
        ...state,
        activeRequests: [...state.activeRequests, action.meta.sourceType],
      }
    case requestActionTypes.ENDED:
      return {
        ...state,
        activeRequests: removeActiveReq(action.meta.sourceType),
      }
    case requestActionTypes.FAILED:
      return {
        ...state,
        activeRequests: removeActiveReq(action.meta.sourceType),
        errors: { ...state.errors, [action.meta.sourceType]: action.error },
      }
    case requestActionTypes.CLEAR_ERROR:
      return {
        ...state,
        errors: {},
      }
    default:
      return state
  }
}

export default requestReducer
